const ACCESS_TOKEN_KEY = 'auth.access_token';
const REFRESH_TOKEN_KEY = 'auth.refresh_token';
const ACCESS_EXPIRES_AT_KEY = 'auth.access_expires_at';

let authStoreModule = {
    namespaced: true,
    state: {
        access_token: '',
        refresh_token: '',
        access_expires_in: '',
    },
    getters: {
        token(state) {
            return state.access_token || sessionStorage.getItem(ACCESS_TOKEN_KEY) || '';
        },
        isAuthenticated(state) {
            return !!(state.access_token || sessionStorage.getItem(ACCESS_TOKEN_KEY));
        },
    },
    actions: {
        loadFromStorage(vm) {
            vm.state.access_token = sessionStorage.getItem(ACCESS_TOKEN_KEY) || '';
            vm.state.refresh_token = localStorage.getItem(REFRESH_TOKEN_KEY) || '';
            vm.state.access_expires_in = sessionStorage.getItem(ACCESS_EXPIRES_AT_KEY) || '';
        },
        resetToken({ commit }) {
            commit('access_token', '');
            commit('refresh_token', '');
            commit('access_expires_in', '');
            sessionStorage.removeItem(ACCESS_TOKEN_KEY);
            sessionStorage.removeItem('auth.access_expires_in');
            sessionStorage.removeItem(ACCESS_EXPIRES_AT_KEY);
            localStorage.removeItem(REFRESH_TOKEN_KEY);
            localStorage.removeItem('auth.refresh_expires_in');
            localStorage.removeItem('auth.refresh_expires_at');
        },
        setToken({ commit }, data) {
            commit('access_token', data.access_token);
            commit('refresh_token', data.refresh_token || '');
            commit('access_expires_in', data.expires_in || 0);
        },
    },
    mutations: {
        access_token(state, data) {
            state.access_token = data;
            sessionStorage.setItem(ACCESS_TOKEN_KEY, data);
        },
        refresh_token(state, data) {
            state.refresh_token = data;
            localStorage.setItem(REFRESH_TOKEN_KEY, data);
        },
        access_expires_in(state, data) {
            state.access_expires_in = Math.floor(Date.now()) + (data * 1000);
            sessionStorage.setItem(ACCESS_EXPIRES_AT_KEY, state.access_expires_in);
        },
    },
};

export default authStoreModule;
